import * as types from "./types";
import { urlService } from "../../utils/urlService";
import axiosInstance from "../../Axios/axiosInstance";

export const loadingSearchResults = (payload) => {
  return {
    type: types.IS_LOADING_SEARCH_RESULTS,
    payload,
  };
};

export const emptySearchResults = () => {
  return {
    type: types.EMPTY_SEARCH_RESULTS,
  };
};

export const setSelectedLocation = (payload) => {
  return {
    type: types.SET_SELECTED_LOCATION,
    payload,
  };
};

export const resetSelectedLocation = () => {
  return {
    type: types.DELETE_SELECTED_LOCATION,
  };
};
 
export const globalSearch = (
  searchText = "",
  latitude,
  longitude,
  userId,
  favourite,
  country,
  isUserLoggedIn,
  dentalConditionSearchedText = "",
  insurancePlan = "",
) => {
  return async(dispatch) => {
    dispatch(loadingSearchResults(true));

    const requestedParams = {
      latitude,
      longitude,
      country,
      searchKeyword: searchText,
      page: 1,
    }

    const requestedParamsLookup = {
      searchKeyword: searchText,
      type:'provider_speciality',
    }

    const requestedParamsProvider = {
      dentalCondition: dentalConditionSearchedText,
      insuranceId: insurancePlan,
    }

    const providerUrl = isUserLoggedIn ? `/practice/providers/patients?${urlService.objectToQueryString(
      {...requestedParams, ...requestedParamsProvider, favourite}
    )}
    ` : `/practice/providers?${urlService.objectToQueryString(
    {...requestedParams, ...requestedParamsProvider}
    )}
    `;
    const clinicUrl = isUserLoggedIn ? `/practice/office/patients?${urlService.objectToQueryString(
      {...requestedParams, typeOfCare: dentalConditionSearchedText, favourite}
    )}
    `: `/practice/office?${urlService.objectToQueryString(
      {...requestedParams, typeOfCare: dentalConditionSearchedText}
    )}
    `;
    const dataLookup = `/practice/master-data/lookups?${urlService.objectToQueryString(
      {...requestedParamsLookup}
    )}`;

    try{
      const [providerRes, clinicRes, dataLookupRes] = await Promise.all([
        axiosInstance.get(providerUrl),
        axiosInstance.get(clinicUrl),
        axiosInstance.get(dataLookup),
      ]);

      const combinedData = {
        providers: providerRes?.data?.data || [],
        clinics: clinicRes?.data?.data || [],
        speciality: dataLookupRes?.data?.data || [],
      };
    
      dispatch({
        type: types.GLOBAL_SEARCH,
        payload: combinedData,
      });

    }catch(error){
      console.error("Global search error:", error);
    }finally{
      dispatch(loadingSearchResults(false));
    }
  }
}

export const loadingCurrentLocation = (payload) => {
  return {
    type: types.IS_LOADING_CURRENT_LOCATION,
    payload,
  };
};

export const errorCurrentLocation = (payload) => {
  return {
    type: types.IS_ERROR_CURRENT_LOCATION,
    payload,
  };
};

export const deleteCurrentLocation = () => {
  return {
    type: types.DELETE_CURRENT_LOCATION,
  };
};

export const setIsGettingCurrentLocationInfo = (payload) => {
  return {
    type: types.IS_GETTING_CURRENT_LOCATION_INFO,
    payload,
  };
};

export const setCurrentLocationInfo = (payload) => {
  return {
    type: types.CURRENT_LOCATION_INFO,
    payload,
  };
};

export const setCurrentLocation = (position) => {
  return (dispatch) => {
    if (position) {
      dispatch({
        type: types.SET_CURRENT_LOCATION,
        payload: { latitude: position.latitude, longitude: position.longitude },
      });
      dispatch(errorCurrentLocation(false));
    } else {
      dispatch(loadingCurrentLocation(true));
      dispatch(deleteCurrentLocation());
      window.navigator.geolocation.getCurrentPosition(
        (navigatorPosition) => {
          dispatch(errorCurrentLocation(false));
          const { latitude, longitude } = navigatorPosition.coords;
          dispatch({
            type: types.SET_CURRENT_LOCATION,
            payload: { latitude, longitude },
          });
          dispatch(loadingCurrentLocation(false));
        },
        () => {
          dispatch(loadingCurrentLocation(false));
          dispatch(errorCurrentLocation(true));
          dispatch(deleteCurrentLocation());
        }
      );
    }
  };
};
